/* Luzzart · PDP de Natal: botões "+ Adicionar" do bloco "Complete a decoração".
   Adiciona 1 unidade por /cart/add.js, atualiza o contador e a gaveta do carrinho em silêncio (não abre a gaveta: a pessoa continua na página). */
(function () {
  'use strict';
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function applyHeader(sections) {
    var b = sections && sections['cart-icon-bubble'], bubble = document.getElementById('cart-icon-bubble');
    if (b && bubble) { var d = parse(b), inner = d.querySelector('.shopify-section'); bubble.innerHTML = inner ? inner.innerHTML : d.body.innerHTML; }
    var dr = sections && sections['cart-drawer'], drawer = document.getElementById('CartDrawer');
    if (dr && drawer) { var nd = parse(dr).querySelector('#CartDrawer'); if (nd) drawer.innerHTML = nd.innerHTML; }
    // como o product-form do tema: sem tirar o "is-empty", a gaveta prende o foco num ".drawer-empty" que não existe
    var cd = document.querySelector('cart-drawer');
    if (cd && cd.classList) cd.classList.remove('is-empty');
    if (typeof window.freeShippMsg === 'function') { try { window.freeShippMsg(); } catch (e) {} }
  }
  function init(box) {
    var err = box.querySelector('[data-lze-combo-err]'), live = box.querySelector('[data-lze-combo-live]');
    function showErr(msg) { if (!err) return; if (msg) { err.textContent = msg; err.hidden = false; } else err.hidden = true; }
    Array.prototype.forEach.call(box.querySelectorAll('[data-lze-combo-add]'), function (btn) {
      var label = btn.textContent, busy = false;
      btn.addEventListener('click', function () {
        if (busy) return;
        if (btn.getAttribute('aria-disabled') === 'true') return;
        busy = true; showErr(''); btn.setAttribute('aria-busy', 'true');
        var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add').replace(/\.js$/, '') + '.js';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: Number(btn.getAttribute('data-variant-id')), quantity: 1, sections: 'cart-icon-bubble,cart-drawer', sections_url: window.location.pathname })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; }); })
          .then(function (res) {
            if (!res.ok || res.json.status) { var e = new Error((res.json && (res.json.description || res.json.message)) || 'add'); e.status = res.status; throw e; }
            applyHeader(res.json.sections);
            var t = btn.getAttribute('data-title') || '';
            btn.textContent = 'Adicionado ✓'; btn.setAttribute('aria-disabled', 'true');
            btn.setAttribute('aria-label', t + ' adicionado ao carrinho');
            if (live) live.textContent = t + ' adicionado ao carrinho.';
          })
          .catch(function (e) {
            btn.textContent = label;
            var m = 'Não foi possível adicionar. Tente de novo.';
            if (e && e.status === 429) m = 'Muitas tentativas seguidas. Espere alguns segundos e tente de novo.';
            else if (e instanceof TypeError) m = 'Sem conexão. Confira a internet e tente de novo.';
            showErr(m);
          })
          .then(function () { busy = false; btn.removeAttribute('aria-busy'); });
      });
    });
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-lze-combo]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
